import React, { useState, useEffect, useRef, useCallback } from "react";
import styled from "styled-components";
import { format, addDays } from "date-fns";
import image from "../assets/images/profil-picto.png";
import arrowlineleft from "../assets/icons/ArrowLineLeft-s.svg";
import ArrowLineRight from "../assets/icons/ArrowLineRight-s.svg";
import MenuHeader from "./MenuHeader";
import Modal from "react-modal";
import { endpoints } from "../utils/utils";
import useApi from "../hooks/useApi";
import CalendarManagementService from "../services/calendar_management.service";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import Select from "react-select";
import UserService from "../services/user.service";
import { useNotifications } from "../context/NotificationProvider";
import useAuth from "../hooks/useAuth";
import { StaticTimePicker } from "@mui/x-date-pickers/StaticTimePicker";
import { CiClock2 } from "react-icons/ci";
import { asTitle } from "../shared/utils/string";
import { fr, enUS } from 'date-fns/locale';
import { Alert, AlertTitle, List, ListItem, Paper, Stack } from '@mui/material';
import {
  Menu,
  MenuList,
  MenuItem,
  IconButton,
  ListItemText,
  ListItemIcon,
  Autocomplete,
  TextField,
  Divider,
  Button,
  Typography,
  Box,
  Icon,
  Chip,
} from "@mui/material";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import ZoneService from "../services/zone.service";
import {
  Close,
  Folder,
  CloudUploadRounded,
  DragIndicator,
} from "@mui/icons-material";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { useLocation } from "react-router-dom";
import ViewListIcon from "@mui/icons-material/ViewList";
import GridViewIcon from "@mui/icons-material/GridView";
import OptimizedCalendarGrid from "./OptimizedCalendarGrid";
import { useTranslation } from "react-i18next";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import { bindEvent, getPusher, initPusher } from "../services/pusher.service";

const STATUS_MAPPINGS = {
  B: "Bank Holiday",
  S: "Sick Leave",
  H: "Holiday",
  O: "Day Off",
};



const theme = createTheme({
  palette: {
    dark: {
      main: "#393D44",
      light: "#676C73",
      dark: "#2A2E34",
      contrastText: "#FAEF9B",
    },
    primary: {
      main: "#393D44",
    },
    secondary: {
      main: "rgba(0, 0, 0, 0.3)",
    },
  },
});
const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});
const timerStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    transform: "translate(-50%, -50%)",
    position: "absolute",
    boxshadow: "0 0 10px rgba(0, 0, 0, 0.5)",
    overflowX: "hidden",
    maxWidth: "350px",
    padding: "0px 0px 0px 0px",
  },
};

const Container = styled.div`
  display: flex;
  height: calc(100vh - 162px);
  font-family: Arial, sans-serif;
  margin-left: 30px;
  flex-wrap: nowrap;
  overflow-x: auto;
`;

const Sidebar = styled.div`
  position: relative;
  max-width: 240px;
  display: flex;
  flex-direction: column;
  gap: 5px;
  align-items: center;
`;

const CalendarContainer = styled.div`
  flex: 1;
  padding: 0 20px;
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 5px;
  max-width: calc(100vw - 270px);
  min-width: 800px;
`;

const Header = styled.div`
  width: fit-content;
  margin-bottom: 12px;
  position: relative;
`;

const TimeSlots = styled.div`
  display: grid;
  grid-template-columns: repeat(900, 1fr);
  position: relative;

  width: 100%;
  background: rgba(0, 0, 0, 0.08);
  box-shadow: 0px 8px 50px rgba(0, 0, 0, 0.08);
  border-radius: 40px;
  background-color: #fff;
  height: 47px;
  padding: 0px 25px;
  white-space: nowrap;
`;

const TimeSlot = styled.div`
  background-color: ${({ $status }) => {
    if ($status === "AVAILABLE") return "#96ca63";
    if ($status === "OVER_TIME") return "#ADFF2F";
    if ($status === "BOOKED") return "#FF0000";
    if ($status === "BUFFER") return "#8A2BE2";
    if ($status === "TRAVEL") return "#8A2BE2";
    if ($status === "OFF") return "#000000";
    if ($status === "HOLIDAY") return "#1E88E5";
    if ($status === "BANK_HOLIDAY") return "#582900";
    if ($status === "SICK_LEAVE") return "#808080";
    return "transparent";
  }};
  width: 100%;
  position: relative;
  border-radius: 8px;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  flex-wrap: wrap;
  align-content: flex-start;
  min-heigth: 23px;
  padding: 12px 5px;
  box-sizing: border-box;
  text-align: left;
  font-size: 12px;
  color: #fff;
  height: 47px;
  font-family: Inter;
  padding-left: 0 !important;
  padding-right: 0 !important;
`;

const HourLabel = styled.div`
  position: relative;
  font-size: 11px;
  line-height: 16px;
  font-family: Inter;
  color: rgba(0, 0, 0, 0.4);
  text-align: left;
  display: inline-block;
  height: 17px;
`;

const TimeText = styled.div`
  color: ${({ status }) => (status === "OVER_TIME" ? "black" : "white")};
  font-size: 14px;
  overflow: hidden;
  padding: 0 10px;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const DurationText = styled.div`
  width: 100%;
  position: relative;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  text-align: left;
  font-size: 12px;
  color: ${({ status }) => (status === "OVER_TIME" ? "black" : "white")};
  font-family: Inter;
  margin: 0;
  font-weight: 900;
  font-family: Lato;
`;

const CurrentTimeWrapper = styled.div`
  position: fixed;
  top: ${({ scrollposition }) =>
    scrollposition > 70 ? 163 : 230 - scrollposition}px;
  left: calc(${({ $left }) => 100}%);
  height: 100vh;
  width: 10px;
  cursor: pointer;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  z-index: 11;
`;

const CurrentTimeIndicatorLine = styled.div`
  width: 2px;
  background-color: black;
  height: 100%;
`;

const TooltipCustom = styled.div`
  display: none;
  position: absolute;
  top: 0;
  left: -70px;
  background-color: black;
  color: white;
  padding: 5px 8px;
  border-radius: 10px;
  white-space: nowrap;
  font-size: 12px;
  font-family: Inter, sans-serif;

  &::after {
    content: "";
    position: absolute;
    top: 50%;
    right: -10px;
    transform: translateY(-50%);
    border-width: 5px;
    border-style: solid;
    border-color: transparent transparent transparent black;
  }

  ${CurrentTimeWrapper}:hover & {
    display: block;
  }
`;
const HtmlTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    background: "#EEEEEE",
    color: "rgba(0, 0, 0, 0.87)",
    maxWidth: 249,
    fontSize: 12,
    border: "1px solid rgba(179, 190, 197, 1)",
    borderRadius: "#EEEEEE",
  },
}));
/* START Remove Comment if revert to Dots
const Dots = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const Dot = styled.div`
  width: 10px;
  height: 10px;
  border-radius: 100%;
  background-color: ${({ color }) => color};
`;
END Remove Comment if revert to Dots */

const Legend = styled.div`
  width: 10px;
  height: 10px;
  border-radius: ${({ type }) => (type === "dot" ? "100%" : "0")};
  background-color: ${({ color }) => color};
`;


const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    maxHeight: '90vh',
    overflowY: 'auto', 
  },
  overlay: {
    zIndex: 1000,
  },
};

const generateHours = (startHour, endHour) => {
  const hoursArray = [];
  for (let h = startHour; h <= endHour; h++) {
    const formattedHour = `${String(h).padStart(2, "0")}:${String(0).padStart(
      2,
      "0"
    )}`;
    hoursArray.push(formattedHour);
  }
  return hoursArray;
};

const getIndexOfHour = (startHour, targetHour, interval) => {
  const convertToMinutes = (timeString) => {
    const [hour, minute] = timeString.split(":").map(Number);
    return hour * 60 + minute;
  };

  const startTimeInMinutes = convertToMinutes(startHour);
  const targetTimeInMinutes = convertToMinutes(targetHour);

  const minutesDifference = targetTimeInMinutes - startTimeInMinutes;

  const index = minutesDifference / interval;

  return index;
};

const hours = generateHours(8, 22);

const calculateDuration = (start, end) => {
  const parseTime = (timeStr) => {
    let [hour, minute] = timeStr.split(":").map(Number);
    return hour * 60 + minute;
  };

  const startTotalMinutes = parseTime(start);
  const endTotalMinutes = parseTime(end);
  const durationMinutes = endTotalMinutes - startTotalMinutes;
  const totalMinutes =
    durationMinutes >= 0 ? durationMinutes : 24 * 60 + durationMinutes;

  const durationHours = Math.floor(totalMinutes / 60);
  const durationRemMinutes = totalMinutes % 60;

  return `${durationHours}:${String(durationRemMinutes).padStart(2, "0")}`;
};

const calculateDiffInMinutes = (start, end) => {
  const parseTime = (timeStr) => {
    let [hour, minute] = timeStr.split(":").map(Number);
    return hour * 60 + minute;
  };
  return parseTime(end) - parseTime(start);
};

const Calendar = () => {
  const { t, i18n } = useTranslation(["calendar"]);
  const legends = [
    { label: t('legends.normalHours'), type: "square", color: "#96ca63" },
    { label: t('legends.extraHours'), type: "square", color: "#ADFF2F" },
    { label: t('legends.booked'), type: "square", color: "#FF0000" },
    { label: t('legends.travel'), type: "square", color: "#8A2BE2" },
    { label: t('legends.dayOff'), type: "square", color: "#000000" },
    { label: t('legends.holiday'), type: "square", color: "#1E88E5" },
    { label: t('legends.bankHoliday'), type: "square", color: "#582900" },
    { label: t('legends.sickLeave'), type: "square", color: "#808080" },
  ];

  const statuses = new Map([
    ["AVAILABLE", t('status.AVAILABLE')],
    ["OVER_TIME", t('status.overTime')],
    ["BOOKED", t('status.booked')],
    ["BUFFER", t('status.buffer')],
    ["TRAVEL", t('status.travel')],
    ["OFF", t('status.off')],
    ["HOLIDAY", t('status.holiday')],
    ["BANK_HOLIDAY", t('status.bankHoliday')],
    ["SICK_LEAVE", t('status.sickLeave')],
    ["FREE_TIME", t('status.freeTime')],
  ]);
  // const STATUS_MAPPINGS = {
  //   'B': t('status.booked'),
  //   'S': t('status.sickLeave'),
  //   'H': t('status.holiday'),
  //   'O': t('status.off')
  // };
  const [currentDate, setCurrentDate] = useState(new Date());
  const [timeSlots, setTimeSlots] = useState([]);
  const [currentTime, setCurrentTime] = useState(new Date());
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [exportModalIsOpen, setExportModalIsOpen] = useState(false);
  const [createModalIsOpen, setCreateModalIsOpen] = useState(false);
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [flypros, setFlypros] = useState([]);
  const [selectedFlyproOption, setSelectedFlyproOption] = useState([]);
  const [timePickerIsOpen, setTimePickerIsOpen] = useState(false);
  const [selectedTime, setSelectedTime] = useState(new Date());

  const api = useApi();

  const [file, setFile] = useState(null);
  const [message, setMessage] = useState("");
  const notify = useNotifications();
  const [formData, setFormData] = useState({
    users: [],
  });
  const { auth } = useAuth();
  const userRoles = auth?.roles;

  const isAdmin = userRoles?.some((role) => role.name === "ROLE_ADMIN");

  const dateInputRef = useRef(null);
  const realtimeRefreshInFlightRef = useRef(false);
  const realtimeLastRefreshRef = useRef(0);
  const refreshCalendarRef = useRef(null);
  const [slots, setSlots] = useState([]);
  const [selectedSlot, setSelectedSlot] = useState({});
  const [minTime, setMinTime] = useState(new Date("1970-01-01T08:00:00"));
  const [maxTime, setMaxTime] = useState(new Date("1970-01-01T22:00:00"));
  const [therapists, setTherapists] = useState([]);
  const [zones, setZones] = useState([]);
  const [filteredZones, setFilteredZones] = useState([]);
  const [filteredTherapists, setFilteredTherapists] = useState([]);
  const [apiResponse, setApiResponse] = useState(null);
  const location = useLocation();
  const [filters, setFilters] = useState({
    therapists: [],
    types: [],
    zones: [],
    labels: [],
  });
  const customSelectStyles = {
    control: (styles) => ({
      ...styles,
      width: "100%",
      height: "60px",
      padding: "0 15px",
      fontSize: "14px",
      lineHeight: "60px",
      color: "#393D44",
      border: "0",
      borderRadius: "20px",
      background: "#ffffff",
    }),
    indicatorSeparator: (base) => ({
      ...base,
      display: "none",
    }),
  };
  const fileInputRef = useRef(null);

  useEffect(() => {
    const initData = async () => {
      // await initFilterData();
      if (location.state?.preselectedTherapist) {
        const therapistResponse = await UserService.indexByRole(
          {
            columns: [
              "id",
              "firstname",
              "lastname",
              "email",
              "status",
              "is_asca",
              "is_rme",
              "agent_type",
            ],
            status: "!eq:BLOCKED",
            with: "zones",
            ...(!isAdmin && { ['flypro_manager_id']: auth?.user?.id })
          },
          "ROLE_FLYPRO",
          api
        );
        const sortedFlypros = therapistResponse.sort((a, b) =>
          (a.firstname || '').localeCompare(b.firstname || '', undefined, { sensitivity: 'base' })
        );
        setTherapists(sortedFlypros);
        const therapist = location.state.preselectedTherapist;
        setFilters({
          therapists: [therapist],
          types: [],
          zones: [],
          labels: [],
        });
        setFilteredTherapists([therapist]);
      } else {
        await initFilterData();
      }
    };

    initData();
  }, []);

  useEffect(() => {
    updateCalendar();
  }, [filteredTherapists, currentDate]);

  const handleReset = () => {
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };
  const handleFileChange = (event) => {
    setFile(event.target.files[0]);
  };
  const handleDragOver = (event) => {
    event.preventDefault(); // Prevent default behavior (to allow drop)
  };

  const handleDrop = (event) => {
    event.preventDefault();
    const droppedFile = event.dataTransfer.files[0];
    if (droppedFile) {
      setFile(droppedFile);
    }
  };
  const openModal = () => setModalIsOpen(true);
  const closeModal = () => {
    setModalIsOpen(false);
    setMessage("");
    setFile(null);
  };
  const handleImport = async () => {
    if (!file) {
      setMessage("Please select a file before importing.");
      return;
    }

    const formData = new FormData();
    formData.append("file", file);

    try {
      const response = await api.post(endpoints.importCalender, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      setMessage(response.data.message || "File imported successfully.");
      updateCalendar();
    } catch (error) {
      setMessage(
        error.response?.data?.message || "An error occurred during import."
      );
    }
  };

  const handleDownload = async (e) => {
    try {
      e.preventDefault();
      const dates = generateDates();

      if (dates && dates.length) {
        if (formData.users && formData.users.length) {
          const response = await api.post(
            endpoints.getCalendarFile,
            {
              users: formData.users,
              dates: dates,
            },
            {
              responseType: "blob",
            }
          );

          const url = window.URL.createObjectURL(new Blob([response.data]));

          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "schedule_template.csv");
          document.body.appendChild(link);
          link.click();

          link.remove();
          window.URL.revokeObjectURL(url);
        }
      }
    } catch (error) { }
  };

  const fetchCalendarData = async (date) => {
    try {
      const therapist_ids = filteredTherapists.length
        ? filteredTherapists.map((therapist) => therapist.id).join(",")
        : -1;
      const params = {
        date: `${new Date(date).toLocaleDateString("en-CA").split("T")[0]}`,
        with: "therapist.media,therapist.zones,calendars_managements_slots.slot",
        therapist_id: `in:${therapist_ids}`,
      };

      const response = await CalendarManagementService.index(params, api);
      console.log({response})
      return response;
    } catch (error) {
      console.error(
        "Erreur lors de la récupération des données du calendrier :",
        error
      );
      throw error;
    }
  };

  const handleFilterChange = (value, type) => {
    let changes = filters;
    switch (type) {
      case "therapists":
        changes = { ...filters, therapists: value };
        break;
      case "zones":
        changes = { ...filters, zones: value };
        break;
      case "types":
        changes = { ...filters, types: value };
        break;
      case "labels":
        changes = { ...filters, labels: value };
        break;
    }
    setFilters(changes);
    if (
      !changes.therapists.length &&
      !changes.types.length &&
      !changes.zones.length &&
      !changes.labels.length
    ) {
      setFilteredTherapists(therapists);
      setFilteredZones(zones);
    }
  };
  const resetFilters = () => {
    setFilteredTherapists(therapists);
    setFilteredZones(zones);
    setFilters({ therapists: [], types: [], zones: [], labels: [] });
  };

  const canFilter =
    filters.therapists.length > 0 ||
    filters.types.length > 0 ||
    filters.zones.length > 0 ||
    filters.labels.length > 0;

  const applyFilters = () => {
    const filteredData = therapists.filter((therapist) => {
      // Filter by therapist IDs
      if (filters.therapists.length) {
        const therapistIds = new Set(
          filters.therapists.map((therapist) => therapist.id)
        );
        if (!therapistIds.has(therapist.id)) {
          return false;
        }
      }

      // Filter by zones
      if (filters.zones.length) {
        setFilteredZones(filters.zones);
        const therapistZoneIds = new Set(
          therapist.zones.map((zone) => zone.id)
        );
        if (!filters.zones.some((zone) => therapistZoneIds.has(zone.id))) {
          return false;
        }
      }

      // Filter by types
      if (filters.types.length) {
        const typeSet = new Set(filters.types); // Optimization: use a Set for faster lookup
        if (!typeSet.has(therapist.agent_type)) {
          return false;
        }
      }

      // Filter by labels (ASCA and RME)
      if (filters.labels.length) {
        const labelSet = new Set(filters.labels); // Optimization: use a Set for faster lookup
        if (
          (labelSet.has("ASCA") && !therapist.is_asca) ||
          (labelSet.has("RME") && !therapist.is_rme)
        ) {
          return false;
        }
      }

      return true;
    });
    setFilteredTherapists(filteredData);
    handleFilterMenuClose();
  };
  const localeFr = { ...fr, options: { ...fr.options, weekStartsOn: 1 } };
  const localeEn = { ...enUS, options: { ...enUS.options, weekStartsOn: 1 } };
  const locale = i18n.language === "fr" ? localeFr : localeEn;
  const initFilterData = async () => {
    try {
      const therapistResponse = await UserService.indexByRole(
        {
          columns: [
            "id",
            "firstname",
            "lastname",
            "email",
            "status",
            "is_asca",
            "is_rme",
            "agent_type",
          ],
          status: "!eq:BLOCKED",
          with: "zones",
          ...(!isAdmin && { ['flypro_manager_id']: auth?.user?.id })
        },
        "ROLE_FLYPRO",
        api
      );
      const sortedFlypros = therapistResponse.sort((a, b) =>
        (a.firstname || '').localeCompare(b.firstname || '', undefined, { sensitivity: 'base' })
      );
      setTherapists(sortedFlypros);
      setFilteredTherapists(therapistResponse);
      const zoneResponse = await ZoneService.index(
        { columns: ["id", "name", "is_active"], is_active: 1 },
        api
      );
      setZones(zoneResponse);
      setFilteredZones(zoneResponse);
    } catch (error) {
      console.error(
        "Erreur lors de la récupération des données du calendrier :",
        error
      );
      throw error;
    }
  };

  const updateCalendar = async () => {
    try {
      const calendarData = await fetchCalendarData(currentDate);

      const groupedData = calendarData.reduce((acc, item) => {
        const therapistEmail = item.therapist.email;

        const validSlots = item.calendars_managements_slots.filter(
          (slot) => slot.status !== "FREE_TIME"
        );

        if (validSlots.length === 0) return acc;

        if (!acc[therapistEmail]) {
          acc[therapistEmail] = {
            ...item.therapist,
            slots: [],
          };
        }

        validSlots.forEach((calendar_management_slot) => {
          acc[therapistEmail].slots.push([
            calendar_management_slot.slot.start_time,
            calendar_management_slot.slot.end_time,
            calendar_management_slot.status,
          ]);
        });

        return acc;
      }, {});
      const therapistEmails = Object.keys(groupedData);

      const adjustAndSplitTimeSlots = (slots) => {
        const minHour = "08:00";
        const maxHour = "18:00";

        // Convert time string to Date object
        const parseTime = (time) => {
          const [hour, minute] = time.split(":").map(Number);
          return new Date(1970, 0, 1, hour, minute);
        };

        // Convert Date object to time string
        const formatTime = (date) => {
          return date.toTimeString().slice(0, 5);
        };

        // Sort slots by start time
        const sortedSlots = slots.sort(
          (a, b) => parseTime(a[0]) - parseTime(b[0])
        );

        const result = [];
        let previousEndTime = parseTime(minHour);

        for (const [startTime, endTime, status] of sortedSlots) {
          const currentStartTime = parseTime(startTime);

          // Add a FREE_TIME slot if there's a gap
          if (currentStartTime > previousEndTime) {
            result.push([
              formatTime(previousEndTime),
              formatTime(currentStartTime),
              "FREE_TIME",
            ]);
          }

          // Add the current slot
          result.push([startTime, endTime, status]);

          // Update the previous end time
          previousEndTime = parseTime(endTime);
        }

        // Add a final FREE_TIME slot if there's a gap to the maxHour
        if (previousEndTime < parseTime(maxHour)) {
          result.push([formatTime(previousEndTime), maxHour, "FREE_TIME"]);
        }
        return result;
      };

      Object.keys(groupedData).forEach((email) => {
        groupedData[email].slots = adjustAndSplitTimeSlots(
          groupedData[email].slots
        );
      });

      const formattedData = Object.values(groupedData);
      setTimeSlots(formattedData);
    } catch (error) {
      console.error("Erreur lors de la mise à jour du calendrier :", error);
    }
  };

  function convertTo12HourFormat(time24) {
    const [hours, minutes] = time24.split(":");
    const hours12 = hours % 12 || 12; // Convert 24-hour to 12-hour format
    const period = hours < 12 ? "AM" : "PM"; // Determine AM/PM
    return `${hours12}:${minutes} ${period}`;
  }

  useEffect(() => {
    const dateString = format(currentDate, "yyyy-MM-dd");
    updateCalendar();
  }, [currentDate, filteredTherapists]);

  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     setCurrentTime(new Date());
  //   }, 60000);

  //   setCurrentTime(new Date());

  //   return () => clearInterval(interval);
  // }, []);

  const calculateCurrentTimeLeft = () => {
    const currentHours = currentTime.getHours();
    const currentMinutes = currentTime.getMinutes();
    const currentTotalMinutes = currentHours * 60 + currentMinutes;

    const startTime = 8 * 60;
    const endTime = 21 * 60 + 59;

    if (currentTotalMinutes < startTime || currentTotalMinutes > endTime) {
      return null;
    }

    const totalDisplayedMinutes = 900;
    const elapsedMinutes = currentTotalMinutes - startTime;
    const leftPercentage = (elapsedMinutes / totalDisplayedMinutes) * 100;
    return leftPercentage;
  };

  const currentTimeLeft = calculateCurrentTimeLeft();

  const changeDate = (days) => {
    setCurrentDate((prevDate) => addDays(prevDate, days));
  };

  const renderHourLabels = () => {
    return hours.map((hour, index) => {
      const displayHour = `${hour}`;
      return (
        <HourLabel
          key={index}
          style={hour === "22:00" ? {} : { width: "calc((100% - 40px) / 14)" }}
        >
          {displayHour}
        </HourLabel>
      );
    });
  };

  function convertTimeToMinutes(time) {
    const [hours, minutes] = time
      .match(/(\d+):(\d+)/)
      .slice(1)
      .map(Number);
    return (hours % 24) * 60 + minutes;
  }
  const formatTimeTo24Hour = (timeStr) => {
    const [time, modifier] = timeStr.split(" ");
    let [hour, minute] = time.split(":").map(Number);

    if (modifier === "PM" && hour < 12) hour += 12;
    if (modifier === "AM" && hour === 12) hour = 0;

    return `${String(hour).padStart(2, "0")}:${String(minute).padStart(
      2,
      "0"
    )}`;
  };
  const handleDatePicker = () => {
    dateInputRef.current.showPicker();
  };
  const renderTimeSlots = () => {
    return timeSlots.flatMap((therapist, tIndex) => {
      return (
        <Box sx={{ display: "flex", paddingX: "20px" }} key={tIndex}>
          {therapist.slots.map(([start, end, status], slotIndex) => {
            const [startHours, startMinutes] = start.split(":").map(Number);
            const [endHours, endMinutes] = end.split(":").map(Number);

            const startTotalMinutes = startHours * 60 + startMinutes;
            const endTotalMinutes = endHours * 60 + endMinutes;

            const diffMinutes = endTotalMinutes - startTotalMinutes;

            const diff = +(diffMinutes / 60).toFixed(2);
            /* START Remove Comment if revert to Dots
        const dots = [];

        switch (status) {
          case 'FREE_TIME':
            for (let i = gridStart; i < gridEnd; i += 15) {
              dots.push(<Dot color='#8FA9B9'></Dot>)
            }
            break;
          case 'OFF':
            for (let i = gridStart; i < gridEnd; i += 15) {
              dots.push(<Dot color='#000000'></Dot>)
            }
            break;
          case 'HOLIDAY':
            for (let i = gridStart; i < gridEnd; i += 15) {
              dots.push(<Dot color='#1E88E5'></Dot>)
            }
            break;
          case 'BANK_HOLIDAY':
            for (let i = gridStart; i < gridEnd; i += 15) {
              dots.push(<Dot color='#582900'></Dot>)
            }
            break;
          case 'SICK_LEAVE':
            for (let i = gridStart; i < gridEnd; i += 15) {
              dots.push(<Dot color='#808080' key={i}></Dot>)
            }
            break;
          case 'TRAVEL':
            for (let i = gridStart; i < gridEnd; i += 15) {
              dots.push(<Dot color='#8A2BE2' key={i}></Dot>)
            }
            break;
        }
        END Remove Comment if revert to Dots */
            return (
              <Tooltip
                title={`${statuses.get(status) ?? ""
                  } ${start} - ${end} (${calculateDuration(start, end)})`}
              >
                <TimeSlot
                  key={`${tIndex}-${slotIndex}`}
                  $status={status}
                  style={{ width: `calc(((100% - 40px) / 14) * ${diff})` }}
                >
                  <TimeText status={status}>
                    {status !== "FREE_TIME"
                      ? `${statuses.get(status) ?? ""
                      } ${start} - ${end} (${calculateDuration(start, end)})`
                      : ""}
                  </TimeText>
                </TimeSlot>
              </Tooltip>
            );
          })}
        </Box>
      );
    });
  };

  const closeExportModal = () => {
    setExportModalIsOpen(false);
  };

  const closeCreateModal = () => {
    setCreateModalIsOpen(false);
    setApiResponse(null);
  };

  const openExportModal = async () => {
    setSelectedFlyproOption([]);
    setFormData({ users: [] });
    setStartDate(new Date());
    setEndDate(new Date());
    const response = await UserService.indexByRole(
      { status: "!eq:BLOCKED", 
      ...(!isAdmin && { ['flypro_manager_id']: auth?.user?.id })
      },
      "ROLE_FLYPRO",
      api
    );
    setFlypros(response);
    setExportModalIsOpen(true);
  };

  const openCreateModal = async () => {
    setSelectedFlyproOption([]);
    setFormData({ users: [] });
    setStartDate(new Date());
    setEndDate(new Date());
    setSlots([{ start_time: "08:00", end_time: "12:00", status: "AVAILABLE" }]);
    const response = await UserService.indexByRole(
      { status: "!eq:BLOCKED",
      ...(!isAdmin && { ['flypro_manager_id']: auth?.user?.id })
      },
      "ROLE_FLYPRO",
      api
    );
    setFlypros(response);
    setCreateModalIsOpen(true);
  };

  const handleCancelClick = () => {
    setTimePickerIsOpen(false);
  };

  const handleTimeChange = (newValue) => {
    setSelectedTime(newValue);
  };

  const handleOkClick = () => {
    const timeString = selectedTime.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
    });
    const newSlots = slots.map((slot, index) =>
      index !== selectedSlot.index
        ? slot
        : {
          ...slot,
          start_time: selectedSlot.is_start
            ? formatTimeTo24Hour(timeString)
            : slot.start_time,
          end_time: selectedSlot.is_end
            ? formatTimeTo24Hour(timeString)
            : slot.end_time,
        }
    );
    setSlots(newSlots);
    setTimePickerIsOpen(false);
  };

  const generateDates = () => {
    if (!startDate || !endDate || startDate > endDate) {
      notify.warn("Please select a valid date range");
      return;
    }

    const dates = [];
    const currentDate = new Date(startDate);

    while (currentDate <= endDate) {
      // Exclude Sundays (0 = Sunday)
      // if (currentDate.getDay() !== 0) {
      dates.push(
        new Date(currentDate).toLocaleDateString("en-CA").split("T")[0]
      );
      // }
      currentDate.setDate(currentDate.getDate() + 1);
    }
    return dates;
  };

  const isSundayOrPast = (date) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0); // Normalize to midnight for accurate comparison
    return date < today; //|| date.getDay() === 0 Disable past dates or Sundays
  };

  // Function to disable Sundays, dates in the past, and dates before the start date
  const isSundayOrBeforeStartDate = (date) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    startDate?.setHours(0, 0, 0, 0);
    if (!startDate) return isSundayOrPast(date); // No start date selected
    return date < today || date < startDate; //|| date.getDay() === 0 Disable past, before start date, and Sundays
  };

  const flyproOptions =
    flypros?.length > 0
      ? flypros.map((row) => ({
        value: row.email,
        label: row.extra?.full_name,
      }))
      : [];
  const flyproIdOptions =
    flypros?.length > 0
      ? flypros.map((row) => ({ value: row.id, label: row.extra?.full_name }))
      : [];

  const handleFlyproChange = (selected) => {
    console.log({ selected });
    if (selected?.length) {
      setSelectedFlyproOption(selected);
      setFormData((prev) => ({
        ...prev,
        users: selected.map((therapist) => therapist.value),
      }));
    } else {
      setSelectedFlyproOption([]);

      setFormData((prev) => ({
        ...prev,
        users: [],
      }));
    }
  };

  const handleCreateSlots = async (e) => {
    e.preventDefault();
    const dates = generateDates();
    const therapists = selectedFlyproOption.map((flypro) => flypro.id);
    const response = await CalendarManagementService.createSlots(
      {
        slots,
        therapists,
        dates,
      },
      api
    );
    
    if (response.conflicts) {
      updateCalendar();
      setApiResponse(response);
      console.log(response)
    } else {
      updateCalendar();
      setCreateModalIsOpen(false);
      setApiResponse(null);
    }
  };

  const [scrollposition, setScrollPosition] = useState(0);

  const handleScroll = () => {
    setScrollPosition(window.scrollY);
  };

  const [actionMenuAnchor, setActionMenuAnchor] = useState(null);
  const actionMenuOpen = Boolean(actionMenuAnchor);

  const handleActionMenuClick = (event) => {
    setActionMenuAnchor(event.currentTarget);
  };

  const handleActionMenuClose = () => {
    setActionMenuAnchor(null);
  };

  const [filterMenuAnchor, setFilterMenuAnchor] = useState(null);
  const filterMenuOpen = Boolean(filterMenuAnchor);

  const handleFilterMenuClick = (event) => {
    setFilterMenuAnchor(event.currentTarget);
  };

  const handleFilterMenuClose = () => {
    setFilterMenuAnchor(null);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  // useEffect(() => {
  //   initFilterData();
  // }, []);

  const [viewType, setViewType] = useState("list");

  const toggleViewType = (viewType) => {
    setViewType(viewType);
  };

  const getFirstDayOfMonthDate = () => {
    const date = new Date();
    date.setDate(1);
    return date;
  };
  const [currentDateForGrid, setCurrentDateForGrid] = useState(
    getFirstDayOfMonthDate()
  );
  const [rows, setRows] = useState([]);
  const [gridTherapists, setGridTherapists] = useState([]);
  const [gridEdit, setGridEdit] = useState(false);

  useEffect(() => {
    if (viewType === "grid" && !gridEdit) {
      const firstDay = new Date(
        currentDateForGrid.getFullYear(),
        currentDateForGrid.getMonth(),
        1
      );
      const lastDay = new Date(
        currentDateForGrid.getFullYear(),
        currentDateForGrid.getMonth() + 1,
        0
      );

      const dates = [];
      for (let day = firstDay; day <= lastDay; day.setDate(day.getDate() + 1)) {
        dates.push(new Date(day));
      }

      fetchGridData(dates);
    }
  }, [
    currentDateForGrid,
    viewType,
    filteredTherapists,
    filteredZones,
    gridEdit,
  ]);

  const fetchGridData = async (dates) => {
    const formatter = new Intl.DateTimeFormat("en-CA", {
      timeZone: "Europe/Zurich",
    });
    try {
      const therapist_ids = filteredTherapists.length
        ? filteredTherapists.map((therapist) => therapist.id).join(",")
        : -1;
      const params = {
        date: `between:${formatter.format(
          new Date(dates[0])
        )},${formatter.format(new Date(dates[dates.length - 1]))}`,
        with: "therapist.media,therapist.zones,calendars_managements_slots.slot",
        therapist_id: `in:${therapist_ids}`,
      };

      const response = await CalendarManagementService.index(params, api);
      const therapists = filteredTherapists.map((therapist) => {
        const calendar = [];
        for (let item of response.filter(
          (item) => item.therapist_id == therapist.id
        )) {
          const free = item.calendars_managements_slots.find(
            (calendar_management_slot) =>
              ["OFF", "HOLIDAY", "BANK_HOLIDAY", "SICK_LEAVE"].includes(
                calendar_management_slot.status
              )
          );
          if (free) {
            switch (free.status) {
              case "OFF":
                calendar[formatter.format(new Date(item.date))] = {
                  value: "Day Off",
                  availability: { start: "08:00", end: "18:00" },
                  changed: false,
                  id: item.therapist.id,
                };
                break;
              default:
                calendar[formatter.format(new Date(item.date))] = {
                  value: asTitle(free.status),
                  availability: { start: "08:00", end: "18:00" },
                  changed: false,
                  id: item.therapist.id,
                };
                break;
            }
          } else {
            const availability = item.calendars_managements_slots
              .filter((calendar_slot) => calendar_slot.status !== "FREE_TIME")
              .reduce(
                (acc, item) => {
                  const slot = item.slot;
                  if (
                    !acc.end ||
                    strToTime(slot.end_time) > strToTime(acc.end)
                  ) {
                    acc.end = slot.end_time;
                  }

                  if (
                    !acc.start ||
                    strToTime(slot.start_time) < strToTime(acc.start)
                  ) {
                    acc.start = slot.start_time;
                  }

                  return acc;
                },
                { end: null, start: null }
              );

            if (availability.end && availability.start) {
              calendar[formatter.format(new Date(item.date))] = {
                availability,
                value: `${availability.start} - ${availability.end}`,
                changed: false,
                id: item.therapist.id,
              };
            } else {
              calendar[formatter.format(new Date(item.date))] = {
                availability: null,
                value: null,
                id: item.therapist.id,
              };
            }
          }
        }
        for (let date of dates) {
          const formattedDate = formatter.format(new Date(date));
          if (!calendar.hasOwnProperty(formattedDate)) {
            calendar[formattedDate] = {
              availability: null,
              value: null,
              id: therapist.id,
            };
          }
        }

        return { ...therapist, calendar };
      });
      setGridTherapists(therapists);
      const rows = new Map();
      for (let date of dates) {
        const current = formatter.format(new Date(date));
        rows.set(current, new Map());
        for (let zone of filteredZones) {
          rows.get(current).set(zone.id, new Map());
          // First, process all therapists for this zone
          const therapistSchedules = [];
          for (let therapist of therapists) {
            if (therapist.zones.findIndex((z) => z.id === zone.id) !== -1) {
              const formattedDate = formatter.format(new Date(date));
              rows
                .get(current)
                .get(zone.id)
                .set(therapist.id, therapist.calendar[formattedDate]);

              // Collect schedules for coverage calculation
              if (therapist.calendar[formattedDate] != null) {
                therapistSchedules.push({
                  therapistId: therapist.id,
                  schedule: therapist.calendar[formattedDate],
                });
              }
            }
          }
          rows
            .get(current)
            .get(zone.id)
            .set("coverage", { normalHours: [], extraHours: [] });
          console.log({ rows });
          // Now process coverage after all therapists are added
          calculateCoverageForZone(current, zone.id, therapistSchedules, rows);
        }
      }

      // Helper function to calculate coverage for a zone
      function calculateCoverageForZone(
        dateIndex,
        zoneId,
        therapistSchedules,
        rows
      ) {
        const coverage = { normalHours: [], extraHours: [] };

        // Define normal hours (08:00-18:00) and extra hours (18:00-22:00) boundaries
        const normalHoursStart = "08:00";
        const normalHoursEnd = "18:00";
        const extraHoursEnd = "22:00";

        // Create Date objects for time comparisons
        const normalStartTime = strToTime(normalHoursStart);
        const normalEndTime = strToTime(normalHoursEnd);
        const extraEndTime = strToTime(extraHoursEnd);

        // Process each therapist's schedule
        for (const { therapistId, schedule } of therapistSchedules) {
          if (!schedule) continue;

          // Skip status values (Bank Holiday, Sick Leave, etc.) from coverage calculation
          if (Object.values(STATUS_MAPPINGS).includes(schedule.value)) {
            continue;
          }

          // Skip schedules without availability data
          if (
            !schedule.availability ||
            !schedule.availability.start ||
            !schedule.availability.end
          ) {
            continue;
          }

          const { start, end } = schedule.availability;
          const startTime = strToTime(start);
          const endTime = strToTime(end);

          // Skip invalid time formats
          if (isNaN(startTime) || isNaN(endTime)) {
            continue;
          }

          // Case 1: Schedule is entirely within normal hours (08:00-18:00)
          if (startTime >= normalStartTime && endTime <= normalEndTime) {
            const duration = calculateDuration(start, end);
            processTimeSegment(coverage.normalHours, start, end, duration);
            continue;
          }

          // Case 2: Schedule is entirely within extra hours (18:00-22:00)
          if (startTime >= normalEndTime && endTime <= extraEndTime) {
            const duration = calculateDuration(start, end);
            processTimeSegment(coverage.extraHours, start, end, duration);
            continue;
          }

          // Case 3: Schedule spans both normal and extra hours
          if (startTime < normalEndTime && endTime > normalEndTime) {
            // Calculate durations for normal and extra portions
            const normalDuration = calculateDuration(
              start < normalStartTime ? normalHoursStart : start,
              normalHoursEnd
            );
            const extraDuration = calculateDuration(
              normalHoursEnd,
              end > extraEndTime ? extraHoursEnd : end
            );

            // Process normal hours portion (if any)
            if (startTime < normalEndTime) {
              const normalStart =
                startTime < normalStartTime ? normalHoursStart : start;
              processTimeSegment(
                coverage.normalHours,
                normalStart,
                normalHoursEnd,
                normalDuration
              );
            }

            // Process extra hours portion (if any)
            if (endTime > normalEndTime) {
              const extraEnd = endTime > extraEndTime ? extraHoursEnd : end;
              processTimeSegment(
                coverage.extraHours,
                normalHoursEnd,
                extraEnd,
                extraDuration
              );
            }
          }

          // Case 4: Schedule starts before normal hours but ends within normal hours
          else if (
            startTime < normalStartTime &&
            endTime <= normalEndTime &&
            endTime > normalStartTime
          ) {
            const duration = calculateDuration(normalHoursStart, end);
            processTimeSegment(
              coverage.normalHours,
              normalHoursStart,
              end,
              duration
            );
          }

          // Case 5: Schedule starts within normal hours but extends beyond extra hours
          else if (
            startTime >= normalStartTime &&
            startTime < normalEndTime &&
            endTime > extraEndTime
          ) {
            // Normal hours portion
            const normalDuration = calculateDuration(start, normalHoursEnd);
            processTimeSegment(
              coverage.normalHours,
              start,
              normalHoursEnd,
              normalDuration
            );

            // Extra hours portion
            const extraDuration = calculateDuration(
              normalHoursEnd,
              extraHoursEnd
            );
            processTimeSegment(
              coverage.extraHours,
              normalHoursEnd,
              extraHoursEnd,
              extraDuration
            );
          }

          // Case 6: Schedule spans the entire day (before normal hours to after extra hours)
          else if (startTime < normalStartTime && endTime > extraEndTime) {
            // Normal hours portion
            const normalDuration = calculateDuration(
              normalHoursStart,
              normalHoursEnd
            );
            processTimeSegment(
              coverage.normalHours,
              normalHoursStart,
              normalHoursEnd,
              normalDuration
            );

            // Extra hours portion
            const extraDuration = calculateDuration(
              normalHoursEnd,
              extraHoursEnd
            );
            processTimeSegment(
              coverage.extraHours,
              normalHoursEnd,
              extraHoursEnd,
              extraDuration
            );
          }
        }

        // Sort the hours arrays by start time
        coverage.normalHours.sort(
          (a, b) => strToTime(a.start) - strToTime(b.start)
        );
        coverage.extraHours.sort(
          (a, b) => strToTime(a.start) - strToTime(b.start)
        );

        // Update the coverage for this zone
        rows.get(dateIndex).get(zoneId).set("coverage", coverage);
      }

      // Helper function to process a time segment and add it to the hours array
      function processTimeSegment(hoursArray, start, end, duration) {
        if (hoursArray.length === 0) {
          // First entry
          hoursArray.push({ start, end, duration });
          return;
        }

        // Try to merge with existing segments
        let merged = false;
        for (let i = 0; i < hoursArray.length; i++) {
          const segment = hoursArray[i];

          // Case 1: Current segment ends exactly where new one starts
          if (segment.end === start) {
            segment.end = end;
            segment.duration = calculateDuration(segment.start, segment.end);
            merged = true;
            break;
          }

          // Case 2: New segment ends exactly where current one starts
          if (end === segment.start) {
            segment.start = start;
            segment.duration = calculateDuration(segment.start, segment.end);
            merged = true;
            break;
          }

          // Case 3: Segments overlap
          const segmentStartTime = strToTime(segment.start);
          const segmentEndTime = strToTime(segment.end);
          const newStartTime = strToTime(start);
          const newEndTime = strToTime(end);

          if (
            newStartTime <= segmentEndTime &&
            newEndTime >= segmentStartTime
          ) {
            // Take the earlier start time and later end time
            segment.start =
              newStartTime < segmentStartTime ? start : segment.start;
            segment.end = newEndTime > segmentEndTime ? end : segment.end;
            segment.duration = calculateDuration(segment.start, segment.end);
            merged = true;
            break;
          }
        }

        // If couldn't merge with any existing segment, add as new
        if (!merged) {
          hoursArray.push({ start, end, duration });
        }
      }
      setRows(rows);
      return response;
    } catch (error) {
      console.error(
        "Erreur lors de la récupération des données du calendrier :",
        error
      );
      throw error;
    }
  };

  const normalizeDateKey = (value) => {
    if (!value) {
      return null;
    }

    if (value instanceof Date) {
      return format(value, "yyyy-MM-dd");
    }

    if (typeof value === "string") {
      const trimmed = value.trim();
      if (/^\d{4}-\d{2}-\d{2}$/.test(trimmed)) {
        return trimmed;
      }
    }

    const parsed = new Date(value);
    if (Number.isNaN(parsed.valueOf())) {
      return null;
    }
    return format(parsed, "yyyy-MM-dd");
  };

  const getEventDateKeys = (payload) => {
    const keys = [];
    const pushKey = (value) => {
      const key = normalizeDateKey(value);
      if (key) {
        keys.push(key);
      }
    };

    if (Array.isArray(payload?.dates)) {
      payload.dates.forEach(pushKey);
    }
    if (payload?.date) {
      pushKey(payload.date);
    }
    if (payload?.start_before) {
      pushKey(payload.start_before);
    }

    return keys;
  };

  const buildMonthDates = (anchorDate) => {
    const firstDay = new Date(
      anchorDate.getFullYear(),
      anchorDate.getMonth(),
      1
    );
    const lastDay = new Date(
      anchorDate.getFullYear(),
      anchorDate.getMonth() + 1,
      0
    );

    const dates = [];
    for (
      let day = new Date(firstDay);
      day <= lastDay;
      day.setDate(day.getDate() + 1)
    ) {
      dates.push(new Date(day));
    }
    return dates;
  };

  const refreshCalendar = useCallback(async () => {
    if (viewType === "grid") {
      if (gridEdit) {
        return;
      }
      const dates = buildMonthDates(currentDateForGrid);
      await fetchGridData(dates);
      return;
    }

    await updateCalendar();
  }, [viewType, gridEdit, currentDateForGrid, fetchGridData, updateCalendar]);

  useEffect(() => {
    refreshCalendarRef.current = refreshCalendar;
  }, [refreshCalendar]);

  const scheduleCalendarRefresh = useCallback(() => {
    if (!refreshCalendarRef.current) {
      return;
    }

    if (realtimeRefreshInFlightRef.current) {
      return;
    }

    const now = Date.now();
    if (now - realtimeLastRefreshRef.current < 1500) {
      return;
    }

    realtimeLastRefreshRef.current = now;
    realtimeRefreshInFlightRef.current = true;

    Promise.resolve(refreshCalendarRef.current())
      .catch((error) => {
        console.error("Realtime calendar refresh failed:", error);
      })
      .finally(() => {
        realtimeRefreshInFlightRef.current = false;
      });
  }, []);

  useEffect(() => {
    if (!auth?.accessToken) return;

    initPusher({ token: auth?.accessToken });

    const handler = (data) => {
      const envelope =
        typeof data === "string"
          ? (() => {
              try {
                return JSON.parse(data);
              } catch (_) {
                return {};
              }
            })()
          : data || {};

      const key = envelope?.key;
      if (key !== "calendar" && key !== "availability") {
        return;
      }

      const payload = envelope?.payload || {};
      const therapistIds = [];
      if (Array.isArray(payload?.therapist_ids)) {
        therapistIds.push(...payload.therapist_ids);
      }
      if (payload?.therapist_id) {
        therapistIds.push(payload.therapist_id);
      }

      if (filteredTherapists.length && therapistIds.length) {
        const filterIds = new Set(
          filteredTherapists.map((therapist) => Number(therapist.id))
        );
        const matchesTherapist = therapistIds.some((id) =>
          filterIds.has(Number(id))
        );
        if (!matchesTherapist) {
          return;
        }
      }

      const dateKeys = getEventDateKeys(payload);
      if (dateKeys.length) {
        if (viewType === "list") {
          const currentKey = format(currentDate, "yyyy-MM-dd");
          if (!dateKeys.includes(currentKey)) {
            return;
          }
        } else {
          const startKey = format(
            new Date(
              currentDateForGrid.getFullYear(),
              currentDateForGrid.getMonth(),
              1
            ),
            "yyyy-MM-dd"
          );
          const endKey = format(
            new Date(
              currentDateForGrid.getFullYear(),
              currentDateForGrid.getMonth() + 1,
              0
            ),
            "yyyy-MM-dd"
          );
          const inRange = dateKeys.some(
            (dateKey) => dateKey >= startKey && dateKey <= endKey
          );
          if (!inRange) {
            return;
          }
        }
      }

      scheduleCalendarRefresh();
    };

    const unbind = bindEvent("public-data", "realtime.data.updated", handler);

    return () => {
      unbind();
    };
  }, [
    auth?.accessToken,
    filteredTherapists,
    currentDate,
    currentDateForGrid,
    viewType,
    scheduleCalendarRefresh,
  ]);

  useEffect(() => {
    if (!auth?.accessToken) return;

    initPusher({ token: auth?.accessToken });
    const pusher = getPusher();
    if (!pusher) return;

    const handleConnected = () => {
      scheduleCalendarRefresh();
    };

    pusher.connection.bind("connected", handleConnected);

    return () => {
      pusher.connection.unbind("connected", handleConnected);
    };
  }, [auth?.accessToken, scheduleCalendarRefresh]);

  useEffect(() => {
    const handleOnline = () => {
      scheduleCalendarRefresh();
    };

    window.addEventListener("online", handleOnline);

    return () => {
      window.removeEventListener("online", handleOnline);
    };
  }, [scheduleCalendarRefresh]);

  const strToTime = (timeStr) => {
    const [hours, minutes] = timeStr.split(":");
    return new Date(0, 0, 0, hours, minutes); // Use Date with dummy date to compare time only
  };

  const [draggedValue, setDraggedValue] = useState(null);
  const [isDragging, setIsDragging] = useState(false);
  const [mouseTop, setMouseTop] = useState(0);
  const [mouseLeft, setMouseLeft] = useState(0);

  const handleDragStart = (
    $event,
    { dateIndex, zoneIndex, therapistIndex, therapist }
  ) => {
    setIsDragging(true);
    setMouseLeft($event.pageX);
    setMouseTop($event.pageY);
    // Extract actual value from the therapist object
    const dragValue = therapist?.value || "N/A";
    setDraggedValue({
      dateIndex,
      zoneIndex,
      therapistIndex,
      therapist,
      value: dragValue,
    });
    // console.log({
    //   left: event.pageX,
    //   top: event.pageY
    // });
  };
  const TimeIndicator = () => {
    const [hourDiff, setHourDiff] = useState(0);

    const updateTime = () => {
      const now = new Date();
      const zurich = new Date(
        now.toLocaleString(i18n.language, { timeZone: "Europe/Zurich" })
      );

      const hours = zurich.getHours();
      const minutes = zurich.getMinutes();

      const startHour = 8;
      const totalHours = 13;

      const diff = hours + minutes / 60 - startHour;

      // Clamp between 0 and total range
      setHourDiff(Math.max(0, Math.min(totalHours, diff)));
    };

    useEffect(() => {
      updateTime(); // initial
      const interval = setInterval(updateTime, 60000); // update every minute
      return () => clearInterval(interval);
    }, []);

    return (
      <Box
        sx={{
          position: "absolute",
          height: "100%",
          width: "1px",
          backgroundColor: "black",
          left: `calc(((100% - 40px) / 14) * ${hourDiff})`,
          zIndex: 10,
        }}
      />
    );
  };
  return (
    <>
      <MenuHeader />
      {/* {isAdmin && ( */}
      <div className="bloc-calendar">
        <div className="container">
          <ThemeProvider theme={theme}>
            <Box>
              <IconButton
                color={viewType === "list" ? "primary" : "secondary"}
                id="list"
                onClick={() => toggleViewType("list")}
                title={t("view.list")}
              >
                <ViewListIcon />
              </IconButton>
              <IconButton
                color={viewType === "grid" ? "primary" : "secondary"}
                id="grid"
                onClick={() => toggleViewType("grid")}
                title={t("view.grid")}
              >
                <GridViewIcon />
              </IconButton>
            </Box>
          </ThemeProvider>

          {
            <div className="legend-list">
              {legends.map((legend, index) => (
                <div className="legend" key={index}>
                  <Legend color={legend.color} type={legend.type}></Legend>
                  <span>{legend.label}</span>
                </div>
              ))}
            </div>
          }
          <div className="search" />

          <div className="actions">
            <IconButton onClick={handleActionMenuClick}>
              <img src="assets/images/icon-commandes.svg" alt="actions" />
            </IconButton>
            <Menu
              anchorEl={actionMenuAnchor}
              open={actionMenuOpen}
              onClose={handleActionMenuClose}
            >
              <MenuList style={{ minWidth: 250 }}>
                <MenuItem
                  style={{ gap: 15 }}
                  onClick={() => {
                    handleActionMenuClose();
                    openExportModal();
                  }}
                >
                  <ListItemIcon>
                    <img src="assets/images/icon-excel.svg" alt="actions" />
                  </ListItemIcon>
                  <ListItemText>{t('actions.download')}</ListItemText>
                </MenuItem>
                <MenuItem
                  style={{ gap: 15 }}
                  onClick={() => {
                    handleActionMenuClose();
                    openModal();
                  }}
                >
                  <ListItemIcon>
                    <img src="assets/images/icon-excel.svg" alt="actions" />
                  </ListItemIcon>
                  <ListItemText>{t('actions.import')}</ListItemText>
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    handleActionMenuClose();
                    openCreateModal();
                  }}
                >
                  <ListItemIcon>
                    <img src="assets/images/icon-commandes.svg" alt="actions" />
                  </ListItemIcon>
                  <ListItemText>{t('actions.create')}</ListItemText>
                </MenuItem>
              </MenuList>
            </Menu>
            <IconButton onClick={handleFilterMenuClick}>
              <img src="assets/images/filter.png" alt="actions" height={20} />
            </IconButton>
            <Menu
              anchorEl={filterMenuAnchor}
              open={filterMenuOpen}
              onClose={handleFilterMenuClose}
            >
              <MenuList style={{ padding: 0 }}>
                <MenuItem onClick={handleFilterMenuClose} disableRipple>
                  <ListItemIcon>
                    <img
                      src="assets/images/filter.png"
                      alt="actions"
                      height={20}
                    />
                  </ListItemIcon>
                  <ListItemText>{t('filters.title')}</ListItemText>
                </MenuItem>
                <Divider></Divider>
                <MenuItem disableRipple>
                  <Autocomplete
                    multiple
                    id="therapists"
                    options={therapists}
                    getOptionLabel={(option) => option.extra.full_name}
                    onChange={($event, value) =>
                      handleFilterChange(value, "therapists")
                    }
                    value={filters.therapists}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label={`${t('filters.title')} ${t('filters.therapists')}`}

                        placeholder="Search"
                      />
                    )}
                    sx={{ width: "500px" }}
                  />
                </MenuItem>
                <MenuItem disableRipple>
                  <Autocomplete
                    multiple
                    id="zones"
                    options={zones}
                    getOptionLabel={(option) => option.name}
                    onChange={($event, value) =>
                      handleFilterChange(value, "zones")
                    }
                    value={filters.zones}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label={`${t('filters.title')} ${t('filters.zones')}`}

                        placeholder="Search"
                      />
                    )}
                    sx={{ width: "500px" }}
                  />
                </MenuItem>

                <MenuItem disableRipple unselectable="off">
                  <Autocomplete
                    multiple
                    id="types"
                    options={["EMPLOYEE", "FREELANCER", "EMPLOYEE_EXTRA"]}
                    getOptionLabel={(option) => asTitle(option)}
                    onChange={($event, value) =>
                      handleFilterChange(value, "types")
                    }
                    value={filters.types}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label={`${t('filters.title')} ${t('filters.types')}`}
                        placeholder="Search"
                      />
                    )}
                    sx={{ width: "250px" }}
                  />
                  <Autocomplete
                    multiple
                    id="labels"
                    options={["ASCA", "RME"]}
                    getOptionLabel={(option) => option}
                    onChange={($event, value) =>
                      handleFilterChange(value, "labels")
                    }
                    value={filters.labels}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label={`${t('filters.title')} ${t('filters.labels')}`}
                        placeholder="Search"
                      />
                    )}
                    sx={{ width: "250px" }}
                  />
                </MenuItem>
                {canFilter === true && (
                  <MenuItem
                    disableRipple
                    unselectable="off"
                    style={{ gap: 10 }}
                  >
                    <ThemeProvider theme={theme}>
                      <Button
                        variant="contained"
                        color="dark"
                        onClick={applyFilters}
                      >
                        {t('filters.apply')}
                      </Button>
                      <Button
                        variant="text"
                        color="dark"
                        onClick={resetFilters}
                      >
                        {t('filters.reset')}
                      </Button>
                    </ThemeProvider>
                  </MenuItem>
                )}
              </MenuList>
            </Menu>
          </div>
        </div>
      </div>
      {/* )} */}

      {viewType === "list" && (
        <div id="calendar">
          <Container>
            <Sidebar>
              <Header>
                <div className="group-cal">
                  <div className="button-cal">
                    <div className="iconset-cal">
                      <img
                        onClick={() => changeDate(-1)}
                        className="arrowlineleft-s-icon-cal"
                        alt="Previous Day"
                        src={arrowlineleft}
                      />
                    </div>
                  </div>
                  <div className="text-cal">
                    <div className="text1-cal" onClick={handleDatePicker}>
                      {format(currentDate, "EEE dd MMM yyyy", { locale })}
                    </div>
                    <input
                      ref={dateInputRef}
                      type="date"
                      name="current_date"
                      lang={i18n.language === 'fr' ? 'fr-FR' : 'en-GB'} 
                      value={currentDate}
                      onChange={(e) => {
                        setCurrentDate(new Date(e.target.value));
                      }}
                      hidden
                    />
                  </div>
                  <div className="button-cal">
                    <div className="iconset-cal">
                      <img
                        onClick={() => changeDate(1)}
                        className="arrowlineleft-s-icon-cal"
                        alt="Next Day"
                        src={ArrowLineRight}
                      />
                    </div>
                  </div>
                  <div className="button2-cal">
                    <div className="text-cal">
                      <div
                        className="text1-cal"
                        onClick={() => setCurrentDate(new Date())}
                      >
                        {t('navigation.today')}
                      </div>
                    </div>
                  </div>
                </div>
              </Header>
              {timeSlots.map((therapist, index) => {
                const totalHours = therapist?.slots
                  ?.reduce((total, [start, end]) => {
                    const startMinutes = convertTimeToMinutes(start);
                    const endMinutes = convertTimeToMinutes(end);

                    const durationInHours = (endMinutes - startMinutes) / 60;

                    return total + durationInHours;
                  }, 0)
                  .toFixed(2);
                const totalAvailableHours = therapist?.slots
                  ?.filter(
                    ([start, end, status]) =>
                      status === "AVAILABLE" || status === "OVER_TIME"
                  )
                  ?.reduce((total, [start, end]) => {
                    const startMinutes = convertTimeToMinutes(start);
                    const endMinutes = convertTimeToMinutes(end);

                    const durationInHours = (endMinutes - startMinutes) / 60;

                    return total + durationInHours;
                  }, 0)
                  .toFixed(2);

                const totalNonAvailableHours = therapist?.slots
                  ?.filter(
                    ([start, end, status]) =>
                      status !== "AVAILABLE" && status !== "OVER_TIME"
                  )
                  ?.reduce((total, [start, end]) => {
                    const startMinutes = convertTimeToMinutes(start);
                    const endMinutes = convertTimeToMinutes(end);

                    const durationInHours = (endMinutes - startMinutes) / 60;

                    return total + durationInHours;
                  }, 0)
                  .toFixed(2);

                const totalBookedHours = therapist?.slots
                  ?.filter(([start, end, status]) => status === "BOOKED")
                  ?.reduce((total, [start, end]) => {
                    const startMinutes = convertTimeToMinutes(start);
                    const endMinutes = convertTimeToMinutes(end);

                    const durationInHours = (endMinutes - startMinutes) / 60;

                    return total + durationInHours;
                  }, 0)
                  .toFixed(2);

                return (
                  <HtmlTooltip
                    title={
                      <React.Fragment>
                        <div className="calendar-therapist-item">
                          <div className="calendar-therapist-item-header">
                            <img
                              src={therapist.media?.[0]?.original_url ?? image}
                              alt="avatar"
                              className="avatar-img-60"
                            />
                            <div className="therapist-item-title">
                              <div className="calendar-therapist-name">
                                {therapist.firstname} {therapist.lastname}
                              </div>
                              <div className="calendar-therapist-zone">
                                Type:{" "}
                                {therapist.agent_type
                                  ? asTitle(therapist.agent_type)
                                  : "-"}
                              </div>
                              <div className="calendar-therapist-zone">
                                {therapist.zones.length
                                  ? therapist.zones
                                    ?.map((zone) => zone.name)
                                    .join(", ")
                                  : "-"}
                              </div>
                            </div>
                          </div>
                          <div className="calendar-therapist-availibility">
                            <div className="details-items">
                              <p className="availability-therapist">
                                {t('availability.available')}: {totalAvailableHours} Hrs
                              </p>
                              <p className="availability-therapist">
                                {t('availability.booked')}: {totalBookedHours} Hrs
                              </p>
                              <p className="availability-therapist">
                                {t('availability.availability')}:{" "}
                                {(
                                  (parseFloat(totalAvailableHours) /
                                    parseFloat(totalHours)) *
                                  100
                                ).toFixed(2)}
                                %
                              </p>
                            </div>
                          </div>
                        </div>
                      </React.Fragment>
                    }
                  >
                    <div key={index} className="calendar-therapist">
                      <div className="calendar-therapist-item">
                        <div className="calendar-therapist-item-header">
                          <img
                            src={therapist.media?.[0]?.original_url ?? image}
                            alt="avatar"
                            className="avatar-img"
                          />
                          <div className="therapist-item-title">
                            <div className="calendar-therapist-name">
                              {therapist.firstname} {therapist.lastname}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </HtmlTooltip>
                );
              })}
            </Sidebar>

            <CalendarContainer>
              {/* <TimeIndicator /> */}
              <Box
                sx={{
                  display: "flex",
                  backgroundColor: "white",
                  height: "47px",
                  minHeight: "47px",
                  paddingX: "20px",
                  borderRadius: "8px",
                  boxShadow: 1,
                  alignItems: "center",
                  marginBottom: "12px",
                }}
              >
                {renderHourLabels()}
              </Box>
              {renderTimeSlots()}
            </CalendarContainer>
          </Container>
        </div>
      )}

      {viewType === "grid" && (
        <OptimizedCalendarGrid
          rows={rows}
          filteredZones={filteredZones}
          filteredTherapists={filteredTherapists}
          gridEdit={gridEdit}
          setRows={setRows}
          setGridEdit={setGridEdit}
          gridTherapists={gridTherapists}
          currentDateForGrid={currentDateForGrid}
          setCurrentDateForGrid={setCurrentDateForGrid}
          api={api}
        />
      )}

      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Import Modal"
        ariaHideApp={false}
        style={customStyles}
      >
        <h2>{t('actions.importF')}</h2>
        <div className="modal-content">
          {/* <input type="file" onChange={handleFileChange} /> */}
          <ThemeProvider theme={theme}>
            <Button
              component="label"
              color="dark"
              role={undefined}
              variant="outlined"
              tabIndex={-1}
              startIcon={<Folder />}
              sx={{ width: "100%", height: "200px" }}
              onClick={() => {
                handleReset();
                setFile(null);
              }}
              onDragOver={handleDragOver}
              onDrop={handleDrop}
            >
              {!file ? (
                t('drag')
              ) : (
                <>
                  <Typography
                    variant="body2"
                    sx={{
                      flex: 1,
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                    }}
                  >
                    {file.name}
                  </Typography>
                  <IconButton
                    onClick={() => {
                      handleReset();
                      setFile(null);
                    }}
                    size="small"
                    sx={{ color: "red" }}
                  >
                    <Close fontSize="small" />
                  </IconButton>
                </>
              )}
              <VisuallyHiddenInput
                type="file"
                onChange={handleFileChange}
                ref={fileInputRef}
                accept=".csv"
              />
            </Button>
          </ThemeProvider>
        </div>
        <div className="modal-footer">
          <ThemeProvider theme={theme}>
            <Button
              component="label"
              color="dark"
              role={undefined}
              variant="contained"
              startIcon={<CloudUploadRounded />}
              onClick={handleImport}
            >
              {t('import.importButton')}
            </Button>
            <Button
              component="label"
              color="dark"
              role={undefined}
              onClick={closeModal}
            >
              {t('import.close')}
            </Button>
          </ThemeProvider>
        </div>
        {message && <div className="message">{message}</div>}
      </Modal>
      <Modal
        isOpen={exportModalIsOpen}
        onRequestClose={closeExportModal}
        contentLabel="Import Modal"
        ariaHideApp={false}
        style={customStyles}
      >
        <h2>{t('export.export')}</h2>
        <div className="form-inscription">
          <form onSubmit={handleDownload}>
            <LocalizationProvider dateAdapter={AdapterDateFns}
              adapterLocale={i18n.language === 'fr' ? localeFr : localeEn}
              >
              <div className="flex-row align-center space-around">
                <DatePicker
                  label={t('export.dateRange.start')}
                  value={startDate}
                  onChange={(newValue) => {
                    setStartDate(newValue);
                    setEndDate(newValue); // Automatically set end = start
                  }}
                  renderInput={(params) => <TextField {...params} fullWidth />}
                  shouldDisableDate={(date) => isSundayOrPast(date)} // Disable Sundays for start date
                />
                <DatePicker
                  label={t('export.dateRange.end')}
                  value={endDate}
                  onChange={(newValue) => setEndDate(newValue)}
                  renderInput={(params) => <TextField {...params} fullWidth />}
                  shouldDisableDate={(date) => isSundayOrBeforeStartDate(date)} // Disable dates before start date and Sundays
                />
              </div>
            </LocalizationProvider>
            <div className="flex-row">
              <Autocomplete
                multiple
                options={therapists}
                getOptionLabel={(option) => option.extra.full_name}
                onChange={($event, value) => {
                  setSelectedFlyproOption(value);
                  setFormData((prev) => ({
                    ...prev,
                    users: value.map((therapist) => therapist.email),
                  }));
                }}
                value={selectedFlyproOption}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Filter Therapists"
                    placeholder="Search"
                  />
                )}
                sx={{ width: "100%", padding: "0 20px", margin: "10px auto" }}
              />
            </div>
            <button type="submit" className="btn-submit">
              {t('export.download')}
            </button>
          </form>
        </div>
        {message && <div className="message">{message}</div>}
      </Modal>

      <Modal
        isOpen={createModalIsOpen}
        onRequestClose={closeCreateModal}
        contentLabel="Create Slots"
        ariaHideApp={false}
        style={customStyles}
      >
        <Stack spacing={2} sx={{ mt: 2, alignItems: 'center'}}>
          {apiResponse?.warning && (
            <Alert severity="warning" variant="filled">
              {apiResponse.warning}
            </Alert>
          )}

          {apiResponse?.conflicts && apiResponse.conflicts.length > 0 && (
            <Paper
              elevation={3}
              sx={{
                p: 2,
                border: '3px solid',
                borderColor: '#ed6c02',
                backgroundColor: '#FFF',
              }}
            >
              <Typography variant="h6" color="#ed6c02" gutterBottom>
              {t('conflicts')}
              </Typography>
              <List dense>
                {apiResponse.conflicts.map((conflict, index) => (
                  <ListItem key={index} sx={{ alignItems: 'flex-start' }}>
                    <ListItemText
                      primary={`${new Date(conflict.date).toLocaleDateString('fr-FR')} : ${conflict.start_time} - ${conflict.end_time}`}
                      secondary={`${conflict.message} ${conflict.therapist_name}`}
                      primaryTypographyProps={{ fontWeight: 500 }}
                    />
                  </ListItem>
                ))}
              </List>
            </Paper>
          )}
        </Stack>
        <h2>{t('createSlots.title')}</h2>
        <div className="form-inscription">
          <form onSubmit={handleCreateSlots}>
          <LocalizationProvider
              dateAdapter={AdapterDateFns}
              adapterLocale={i18n.language === 'fr' ? localeFr : localeEn}
              >
              <div className="flex-row align-center space-around">
                <DatePicker
                  label={t('export.dateRange.start')}
                  value={startDate}
                  onChange={(newValue) => {
                    setStartDate(newValue);
                    setEndDate(newValue); // Auto set end = start
                  }}
                  renderInput={(params) => <TextField {...params} fullWidth />}
                  shouldDisableDate={(date) => isSundayOrPast(date)} // Disable Sundays for start date
                />
                <DatePicker
                  label={t('export.dateRange.end')}
                  value={endDate}
                  onChange={(newValue) => setEndDate(newValue)}
                  renderInput={(params) => <TextField {...params} fullWidth />}
                  shouldDisableDate={(date) => isSundayOrBeforeStartDate(date)} // Disable dates before start date and Sundays
                />
              </div>
            </LocalizationProvider>
            <div className="flex-row">
              <Autocomplete
                multiple
                options={therapists}
                getOptionLabel={(option) => option.extra.full_name}
                onChange={($event, value) => {
                  setSelectedFlyproOption(value);
                }}
                value={selectedFlyproOption}
                filterSelectedOptions
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={`${t('createSlots.selectTherapists')} *`}
                    placeholder="Search"
                  />
                )}
                sx={{ width: "100%", padding: "0 20px", margin: "10px auto" }}
              />
            </div>
            <h3>{t('createSlots.slots.slots')}</h3>

            {slots.map((slot, index) => (
              <div
                className="flex-row align-center gap-10"
                style={{ justifyContent: "center", margin: "20px 0" }}
                key={index}
              >
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <TimePicker
                    ampm={false}
                    defaultValue={new Date(`1970-01-01T${slot.start_time}:00`)}
                    label={t('export.dateRange.start')}
                    sx={{ maxWidth: "150px" }}
                    onChange={(newValue) => {
                      const newSlots = slots.map((s, i) =>
                        index !== i
                          ? s
                          : {
                            ...s,
                            start_time: newValue.toTimeString().slice(0, 5),
                          }
                      );
                      setSlots(newSlots);
                    }}
                    minTime={
                      index === 0
                        ? new Date("1970-01-01T08:00:00")
                        : new Date(`1970-01-01T${slots[index - 1].end_time}:00`)
                    }
                    maxTime={
                      slots[index]?.end_time
                        ? new Date(`1970-01-01T${slots[index].end_time}:00`)
                        : new Date("1970-01-01T22:00:00")
                    }
                  />
                </LocalizationProvider>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <TimePicker
                    ampm={false}
                    defaultValue={new Date(`2025-01-01T${slot.end_time}:00`)}
                    label={t('export.dateRange.end')}
                    sx={{ maxWidth: "150px" }}
                    onChange={(newValue) => {
                      const newSlots = slots.map((s, i) =>
                        index !== i
                          ? s
                          : {
                            ...s,
                            end_time: newValue.toTimeString().slice(0, 5),
                          }
                      );
                      setSlots(newSlots);
                    }}
                    minTime={
                      slots[index]?.start_time
                        ? new Date(`1970-01-01T${slots[index].start_time}:00`)
                        : new Date("1970-01-01T08:00:00")
                    }
                    maxTime={new Date("1970-01-01T22:00:00")}
                  />
                </LocalizationProvider>
                <div className="flex-row">
                  <Autocomplete
                    disableClearable
                    options={[
                      { label: t("statusO.normalHours"), value: "AVAILABLE" },
                      { label: t("statusO.freeTime"), value: "FREE_TIME" },
                      { label: t("statusO.extraHours"), value: "OVER_TIME" },
                      { label: t("statusO.holiday"), value: "HOLIDAY" },
                      { label: t("statusO.bankHoliday"), value: "BANK_HOLIDAY" },
                      { label: t("statusO.sickLeave"), value: "SICK_LEAVE" },
                      { label: t("statusO.dayOff"), value: "OFF" },
                    ]}
                    getOptionLabel={(option) => option.label}
                    onChange={($event, value) => {
                      const newSlots = slots.map((slot, i) =>
                        index !== i ? slot : { ...slot, status: value.value }
                      );
                      setSlots(newSlots);
                    }}
                    value={{
                      label: statuses.get(slot.status),
                      value: slot.status,
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label={"Status *"}
                        placeholder="Search"
                      />
                    )}
                    sx={{
                      width: "100%",
                      minWidth: "180px",
                    }}
                  />
                </div>

                <button
                  type="button"
                  className="close-button"
                  style={{ border: "none", height: "fit-content" }}
                  onClick={() => {
                    setSlots(slots.filter((slot, i) => index !== i));
                  }}
                >
                  <span className="close-icon">✖</span>
                </button>
              </div>
            ))}
            <button
              type="button"
              className="btn-submit"
              style={{ width: "fit-content", margin: "0 auto", padding: "10px 15px", height: "fit-content" }}
              onClick={() => {
                if (slots[slots.length - 1]?.end_time == "22:00") {
                  notify.warn("You cannot add more slots after 22:00");
                } else {
                  setSlots([
                    ...slots,
                    {
                      start_time: slots[slots.length - 1]
                        ? slots[slots.length - 1].end_time
                        : "08:00",
                      end_time: "22:00",
                      status: "AVAILABLE",
                    },
                  ]);
                }
              }}
            >
              +
            </button>

            <button type="submit" className="btn-submit">
              {t('actions.create')}
            </button>
          </form>
        </div>
        {message && <div className="message">{message}</div>}
      </Modal>
      <Modal
        isOpen={timePickerIsOpen}
        onRequestClose={handleCancelClick}
        style={timerStyles}
        contentLabel="Time Picker Modal"
      >
        <div className="time-picker">
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <StaticTimePicker
              displayStaticWrapperAs="mobile"
              value={selectedTime}
              ampm={false}
              minTime={minTime}
              maxTime={maxTime}
              onChange={handleTimeChange}
              renderInput={(params) => <TextField {...params} />}
            />
            <div className="pickerActions">
              <button className="action-timer" onClick={handleCancelClick}>
                {t('actions.cancel')}
              </button>
              <button className="action-timer" onClick={handleOkClick}>
                OK
              </button>
            </div>
          </LocalizationProvider>
        </div>
      </Modal>
    </>
  );
};

export default Calendar;
